<template>
  <VisaForm country="canada" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" :date-hint="$tt('estimate_entry_date_5_years_valid')" aerial />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
        :hidden-sections="isAdult(applicant.passport.dateOfBirth) ? [] : ['personal']"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" has-issue-date />
          <AddressFields v-model="applicant.address" />
        </template>
        <template #personal>
          <OccupationFields v-model="applicant.occupation" has-seniority />
          <MaritalFields v-model="applicant.marital" />
          <CrimeFields v-model="applicant.crime" />
          <PastTravelsFields v-model="applicant.pastTravels" />
        </template>
      </ApplicantInfo>
    </template>

    <template #review />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import { isAdult } from '~/helpers/date';
import type { Product } from '~/types';

defineProps<{
  products: Product[]
}>();
</script>